import { useEffect } from "react";

export const SidebarToggle = () => {
    useEffect(() => {
        const sidebarToggle = document.body.querySelector('#sidebarToggle');

        if (!sidebarToggle) return;

        // 如果要保留上次的寄送狀態
        // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
        //     document.body.classList.add('sb-sidenav-toggled');
        // }

        const handleClick = (event) => {
            event.preventDefault();
            document.body.classList.toggle('sb-sidenav-toggled');
            localStorage.setItem(
                'sb|sidebar-toggle',
                document.body.classList.contains('sb-sidenav-toggled')
            );
        };

        sidebarToggle.addEventListener('click', handleClick);

        // 清除事件，避免 React 重複綁定
        return () => {
            sidebarToggle.removeEventListener('click', handleClick);
        };
    }, []);
}